<div style="display:flow-root">
  <div style="float:left; width:65%">
    <mat-form-field class="search-input">
      <input placeholder="Filter"
        matInput
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        (matChipInputTokenEnd)="applyFilter($event)">
        <mat-chip-grid #chipList>
        </mat-chip-grid>
      </mat-form-field>
      @for (item of searchItems; track item) {
        <mat-chip-option [selectable]="selectable"
          [removable]="removable" (removed)="remove(item)">
          {{item.name}}
          @if (removable) {
            <mat-icon matChipRemove>cancel</mat-icon>
          }
        </mat-chip-option>
      }
    </div>
    <div style="text-align:right; float:right; width:35%">
      <h2 style="cursor:pointer; display:block;" class="flex-aligned-div" (click)="openDeploymentInformationPopup()">
        Deployment information
        <mat-icon data-html="true" style="color:white">info</mat-icon>
      </h2>

    </div>
  </div>
  <div class="example-container">
    @if (show) {
      <errorcode-new [header]="header" [list]="list" (cancelEvent)="onCancelErrorCodeCreation()"></errorcode-new>
    }
    <table mat-table
      [dataSource]="dataSource" multiTemplateDataRows id="errorcodeproperties"
      class="mat-elevation-z8 mat-table-custom">
      <ng-container matColumnDef="arrow">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element"
          (click)="pushPopElement(element, false)">
          @if (checkExpanded(element, false)) {
            <span class="material-icons">
              expand_less
            </span>
          } @else {
            <span class="material-icons">
              expand_more
            </span>
          }
        </td>

      </ng-container>
      <ng-container matColumnDef="arrow-device">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div [hidden]="this.defaults.controllertype.BK !== 'CT1001'"
            (click)="pushPopElement(element, true)">
            @if (checkExpanded(element, true)) {
              <span class="material-icons">
                expand_less
              </span>
            } @else {
              <span class="material-icons" matTooltip="Devices">
                build
              </span>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="errorcode">
        <th mat-header-cell *matHeaderCellDef> Error Code </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element)) {
            <p [innerHTML]="element.ErrorCode"></p>
          }
          @if (isEditingRow(element)) {
            <mat-form-field floatLabel="auto">
              <input matInput [value]="element.ErrorCode" [(ngModel)]="element.ErrorCode">
            </mat-form-field>
          }
        </td>
        <td mat-cell *matCellDef="let element"> {{element.ErrorCode}}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Description </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.Description"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="nresolutions">
        <th mat-header-cell *matHeaderCellDef> Number of Resolutions </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.Resolutions"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="errorweight">
        <th mat-header-cell *matHeaderCellDef>
          <div class="filter-header-cell">
            <span class="filter-header-label">Error Weight</span>
            <mat-select class='form-control filter' (selectionChange)="filterWeight($event)" [(ngModel)]="weightSelected">
              <mat-option [value]="-1">Select</mat-option>
              @for (weight of errorWeights; track weight) {
                <mat-option [value]="weight">
                  {{ weight }}
                </mat-option>
              }
            </mat-select>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element)) {
            <p style="font-weight: bold"
              [innerHTML]="element.ErrorWeight"
              [class.red]="element.ErrorWeight === 3"
              [class.orange]="element.ErrorWeight === 2"
              [class.yellow]="element.ErrorWeight === 1"
              [class.green]="element.ErrorWeight === 0"
            ></p>
          }
          @if (isEditingRow(element)) {
            <mat-form-field floatLabel="auto">
              <mat-select style="min-width: 200px; color:red" [(ngModel)]="element.ErrorWeight">
                <mat-option [value]="-1">Select</mat-option>
                @for (weight of errorWeights; track weight) {
                  <mat-option [value]="weight">
                    {{ weight }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="controllerblocked">
        <th mat-header-cell *matHeaderCellDef>
          <div class="filter-header-cell">
            <span class="filter-header-label">Controller Blocked</span>
            <mat-select class='form-control filter' placeholder='Select' [(ngModel)]="controllerBlockedSelected" (selectionChange)="filterCheckbox($event, 'controllerblocked')">
              <mat-option value="-1">Select</mat-option>
              <mat-option value="Yes">Available</mat-option>
              <mat-option value="No">Unavailable</mat-option>
            </mat-select>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox [checked]="element.ControllerBlocked" (change)="changeElement(element, 'controllerblocked', $event.checked)" [ngClass]="isEditingRow(element) ? 'black' :''" [disabled]="!isEditingRow(element)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="ispotentialremoteresetfix">
        <th mat-header-cell *matHeaderCellDef>
          <div class="filter-header-cell">
            <span class="filter-header-label">
              Potential Remote Reset Fix?
              <mat-icon matTooltipClass='opmodes-custom-tooltip' data-html="true" matTooltip="Remote Reset potentially could fix the issue">info</mat-icon>
            </span>
            <mat-select class='form-control filter' placeholder='Select' [(ngModel)]="potentialRRFixSelected" (selectionChange)="filterCheckbox($event, 'ispotentialremoteresetfix')">
              <mat-option value="-1">Select</mat-option>
              <mat-option value="Yes">Yes</mat-option>
              <mat-option value="No">No</mat-option>
            </mat-select>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox [checked]="element.IsPotentialRemoteResetFix" (change)="changeElement(element, 'ispotentialremoteresetfix', $event.checked)" [ngClass]="isEditingRow(element) ? 'black' :''" [disabled]="!isEditingRow(element)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="isgoodevent">
        <th mat-header-cell *matHeaderCellDef>
          <div class="filter-header-cell">
            <span class="filter-header-label">Is Good Event?</span>
            <mat-select class='form-control filter' placeholder='Select' (selectionChange)="filterColumn($event, 'isgoodevent')">
              <mat-option [value]="-1">Select</mat-option>
              <mat-option value="true">Yes</mat-option>
              <mat-option value="false">No</mat-option>
            </mat-select>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element)) {
            <mat-checkbox [checked]="element.IsGoodEvent" [ngClass]="isEditingRow(element) ? 'black' :''" [disabled]="true"></mat-checkbox>
          }
          @if (isEditingRow(element)) {
            <mat-select [(ngModel)]="element.IsGoodEvent">
              <mat-option [value]="undefined">Select</mat-option>
              <mat-option [value]="true">Yes</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="component">
        <th mat-header-cell *matHeaderCellDef>
          <div class="filter-header-cell">
            <span class="filter-header-label">Component</span>
            <mat-select multiple class='form-control filter' placeholder='Select' [(ngModel)]="selectedComponents" (selectionChange)="filterComponent()">
              @for (comp of availableComponents; track comp) {
                <mat-option [value]="comp">{{ comp }}</mat-option>
              }
            </mat-select>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element)) {
            <p [innerHTML]="element.Component | bold: dataSource.filter"></p>
          }
          @if (isEditingRow(element)) {
            <mat-form-field floatLabel="auto">
              <input matInput [value]="element.Component" [(ngModel)]="element.Component">
            </mat-form-field>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="stablealertrule">
        <th mat-header-cell *matHeaderCellDef>
          <div class="filter-header-cell">
            <span class="filter-header-label">
              Stable Alert Rule
              <mat-icon matTooltipClass='opmodes-custom-tooltip' data-html="true" matTooltip="Alert rule selector for Stable and Evaluation environments.">info</mat-icon>
            </span>
            <mat-select class='form-control filter' placeholder='Select' (selectionChange)="filterColumn($event, 'stablealertruleid')">
              <mat-option [value]="-1">Select</mat-option>
              @for (dep of alertRules; track dep) {
                <mat-option [value]="dep.Id">
                  {{ dep.Description }}
                </mat-option>
              }
            </mat-select>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element) && !element.StableAlertRuleCat.startsWith('N/A')) {
            <p [innerHTML]="element.StableAlertRuleCat | bold: dataSource.filter"></p>
          }
          @if (isEditingRow(element)) {
            <mat-form-field floatLabel="auto">
              <mat-select style="min-width: 200px; color:red" [(ngModel)]="element.StableAlertRuleCatId">
                @for (dep of alertRules; track dep) {
                  <mat-option [value]="dep.Id">
                    {{ dep.Description }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="prodalertrule">
        <th mat-header-cell *matHeaderCellDef>
          <div class="filter-header-cell">
            <span class="filter-header-label">
              Production Alert Rule
              <mat-icon matTooltipClass='opmodes-custom-tooltip' data-html="true" matTooltip="Alert rule selector for Production environment.">info</mat-icon>
            </span>
            <mat-select class='form-control filter' placeholder='Select' (selectionChange)="filterColumn($event, 'prodalertruleid')">
              <mat-option [value]="-1">Select</mat-option>
              @for (dep of alertRules; track dep) {
                <mat-option [value]="dep.Id">
                  {{ dep.Description }}
                </mat-option>
              }
            </mat-select>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          @if (!isEditingRow(element) && !element.ProdAlertRuleCat.startsWith('N/A')) {
            <p [innerHTML]="element.ProdAlertRuleCat | bold: dataSource.filter"></p>
          }
          @if (isEditingRow(element)) {
            <mat-form-field floatLabel="auto">
              <mat-select style="min-width: 200px; color:red" [(ngModel)]="element.ProdAlertRuleCatId">
                @for (dep of alertRules; track dep) {
                  <mat-option [value]="dep.Id">
                    {{ dep.Description }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <ng-container>
            @if (!isEditingRow(element)) {
              <button mat-icon-button matTooltip="Edit Row" (click)="onRowEditInit(element)">
                <mat-icon>edit</mat-icon>
              </button>
            }
            @if (!isEditingRow(element)) {
              <button mat-icon-button matTooltip="Delete"
                (click)="onDelete(element)">
                <mat-icon>delete</mat-icon>
              </button>
            }
            @if (isEditingRow(element)) {
              <button mat-icon-button matTooltip="Cancel Row" (click)="onRowEditCancel(element)">
                <mat-icon>rotate_left</mat-icon>
              </button>
            }
            @if (checkExpanded(element, false)) {
              <button mat-icon-button matTooltip="Add Resolution" (click)="onCreateNewResol(element)">
                <mat-icon>library_add</mat-icon>
              </button>
            }
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
          @if (element.ErrorCodeResolutions) {
            <div [@detailExpand]="checkExpanded(element, false) ? 'expanded' : 'collapsed'">
              <table mat-table [dataSource]="element.ErrorCodeResolutions" class="mat-subtable-custom" id="errorcoderesolutions">
                <ng-container matColumnDef="failure">
                  <th mat-header-cell *matHeaderCellDef> Failure </th>
                  <td mat-cell *matCellDef="let element2">
                    @if (!isCreatingResol(element2)) {
                      <p [innerHTML]="element2.MaintenanceFailure"></p>
                    }
                    @if (isCreatingResol(element2)) {
                      <mat-form-field floatLabel="auto">
                        <input matInput [value]="element2.MaintenanceFailure" [(ngModel)]="element2.MaintenanceFailure">
                      </mat-form-field>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>
                    Action
                    @if (showKeywordsTooltip(element)) {
                      <mat-icon matTooltipClass='opmodes-custom-tooltip'
                        (click)="onShowKeywords()"
                      matTooltip="Add keyword">star</mat-icon>
                    }
                  </th>
                  <td mat-cell *matCellDef="let element2">
                    @if (!isCreatingResol(element2)) {
                      <div [innerHTML]="highlightTroubleshootingWithKeywords(element2.TroubleShootingAction)"></div>
                    }
                    @if (isCreatingResol(element2)) {
                      <mat-form-field floatLabel="auto">
                        @if (!isShowingKeywordsSelector || element2.ErrorCodeID !== selectedErrorCode) {
                          <input matInput [value]="element2.TroubleShootingAction" [(ngModel)]="element2.TroubleShootingAction"
                            id="errorcode_{{element2.ErrorCodeID}}"
                            (click)="selectTroubleshootingInput(element2)">
                        }
                        @if (element2.ErrorCodeID === selectedErrorCode && isShowingKeywordsSelector) {
                          <mat-select style="max-width:100px"
                            id="keywords_{{element2.ErrorCodeID}}"
                            (selectionChange)="onSelectItem($event.value)"
                            (openedChange)="openedChange($event)"
                            >
                            @for (keyword of keywords; track keyword) {
                              <mat-option [value]="keyword">
                                {{ keyword }}
                              </mat-option>
                            }
                          </mat-select>
                        }
                      </mat-form-field>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="weight">
                  <th mat-header-cell *matHeaderCellDef> Weight </th>
                  <td mat-cell *matCellDef="let element2">
                    @if (!isEditingResol(element2) && !isCreatingResol(element2)) {
                      <p [innerHTML]="element2.TroubleShootingActionWeight"></p>
                    }
                    @if (isEditingResol(element2) || isCreatingResol(element2)) {
                      <mat-form-field floatLabel="auto">
                        <mat-select style="max-width:100px" [(ngModel)]="element2.TroubleShootingActionWeight">
                          @for (weight of resolWeights; track weight) {
                            <mat-option [value]="weight">
                              {{ weight }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="location">
                  <th mat-header-cell *matHeaderCellDef> Location </th>
                  <td mat-cell *matCellDef="let element2">
                    @if (!isEditingResol(element2) && !isCreatingResol(element2)) {
                      <p [innerHTML]="element2.SubSystemGroup"></p>
                    }
                    @if (isEditingResol(element2) || isCreatingResol(element2)) {
                      <mat-form-field floatLabel="auto">
                        <mat-select style="min-width: 150px" [(ngModel)]="element2.SubSystemGroupID" (selectionChange)="onLocationChange(element2)">
                          @for (location of locations; track location) {
                            <mat-option [value]="location.ComponentSubSystemID">
                              {{ location.Description }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="component">
                  <th mat-header-cell *matHeaderCellDef> Component </th>
                  <td mat-cell *matCellDef="let element2">
                    @if (!isEditingResol(element2) && !isCreatingResol(element2)) {
                      <p [innerHTML]="element2.ComponentItem"></p>
                    }
                    @if (isEditingResol(element2) || isCreatingResol(element2)) {
                      <mat-form-field floatLabel="auto">
                        <mat-select style="min-width: 150px" [(ngModel)]="element2.ComponentItemID">
                          @for (component of element2.components; track component) {
                            <mat-option [value]="component.ComponentItemID">
                              {{ component.ComponentKey }} - {{ component.Description }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="cause">
                  <th mat-header-cell *matHeaderCellDef> Cause </th>
                  <td mat-cell *matCellDef="let element2">
                    @if (!isEditingResol(element2) && !isCreatingResol(element2)) {
                      <p [innerHTML]="element2.Cause"></p>
                    }
                    @if (isEditingResol(element2) || isCreatingResol(element2)) {
                      <mat-form-field floatLabel="auto">
                        <mat-select [(ngModel)]="element2.CauseID">
                          @for (cause of causes; track cause) {
                            <mat-option [value]="cause.BusinessKeyID">
                              {{ cause.BK }} - {{ cause.Description }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="resolution">
                  <th mat-header-cell *matHeaderCellDef> Resolution </th>
                  <td mat-cell *matCellDef="let element2">
                    @if (!isEditingResol(element2) && !isCreatingResol(element2)) {
                      <p [innerHTML]="element2.Resolution"></p>
                    }
                    @if (isEditingResol(element2) || isCreatingResol(element2)) {
                      <mat-form-field floatLabel="auto">
                        <mat-select style="min-width: 200px; color:red" [(ngModel)]="element2.ResolutionID">
                          @for (resol of resolutions; track resol) {
                            <mat-option [value]="resol.BusinessKeyID">
                              {{ resol.BK }} - {{ resol.Description }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="partsrequired">
                  <th mat-header-cell *matHeaderCellDef> Parts Required ? </th>
                  <td mat-cell *matCellDef="let element2">
                    <mat-checkbox [checked]="element2.PartsRequired" (change)="changeResol(element2, 'partsrequired', $event.checked)" [ngClass]="isEditingResol(element2) ? 'black' :''" [disabled]="!isEditingResol(element2) && !isCreatingResol(element2)"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="highvaluepart">
                  <th mat-header-cell *matHeaderCellDef> High Value Part ? </th>
                  <td mat-cell *matCellDef="let element2">
                    <mat-checkbox [checked]="element2.HighValuePart" (change)="changeResol(element2, 'highvaluepart', $event.checked)" [ngClass]="isEditingResol(element2) ? 'black' :''" [disabled]="!isEditingResol(element2) && !isCreatingResol(element2)"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element2">
                    @if (!isEditingResol(element2) && !isCreatingResol(element2)) {
                      <button mat-icon-button matTooltip="Edit Row" (click)="onRowResolEditInit(element2)">
                        <mat-icon>edit</mat-icon>
                      </button>
                    }
                    @if (!isCreatingResol(element2)) {
                      <button mat-icon-button matTooltip="Delete" (click)="onDeleteResol(element2)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                    @if (isEditingResol(element2) || isCreatingResol(element2)) {
                      <button mat-icon-button matTooltip="Cancel Row" (click)="onResolEditCancel(element2)">
                        <mat-icon>rotate_left</mat-icon>
                      </button>
                    }
                  </td>
                </ng-container>
                <tr mat-header-row class="subtableheader" *matHeaderRowDef="subcolumnsToDisplay"></tr>
                <tr mat-row *matRowDef="let element2; let i2 = index; columns: subcolumnsToDisplay;"
                  [class.alternative2]="isEditingResol(element2)"
                  [class.alternative3]="isCreatingResol(element2)"
                class="subitem"></tr>
              </table>
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail2">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
          @if (this.defaults.controllertype.BK === 'CT1001') {
            <div [@detailExpand]="checkExpanded(element, true) ? 'expanded' : 'collapsed'">
              <table mat-table [dataSource]="element.DESDevices" class="mat-subtable-custom" id="errorcoderesolutions">
                <ng-container matColumnDef="deviceName">
                  <th mat-header-cell *matHeaderCellDef> DeviceName </th>
                  <td mat-cell *matCellDef="let element2">
                    <p [innerHTML]="element2.DeviceName"></p>
                  </td>
                </ng-container>
                <ng-container matColumnDef="sentByDevice">
                  <th mat-header-cell *matHeaderCellDef> Is Sent By Device? </th>
                  <td mat-cell *matCellDef="let element2">
                    <mat-checkbox [checked]="element2.SentByDevice" [disabled]="true"></mat-checkbox>
                  </td>
                </ng-container>
                <tr mat-header-row class="subtableheader" *matHeaderRowDef="desSubcolumns"></tr>
                <tr mat-row *matRowDef="let element2; let i2 = index; columns: desSubcolumns;"
                class="subitem"></tr>
              </table>
            </div>
          }
        </td>
      </ng-container>


      <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;"
        class="item"
      [class.alternative2]="isEditingRow(element)"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="row-subitem"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail2']" class="row-subitem"></tr>
    </table>
  </div>



